import {createContext, useContext} from "react";
import type {CreateReviewAction, Owner, OwnerPayload} from "platformed-client/types";
import type {ReviewMap} from "./reviewsShared";

/**
 * Where the review components read and write reviews when they are not backed by the API: the
 * reviews to show, how review actions are recorded, and how picked users and teams become owners.
 * Absent, the components load the entity's reviewable and write through its review endpoint.
 */
export interface ReviewSource {
  reviews: ReviewMap;
  createReviews: (requests: CreateReviewAction[]) => Promise<void>;
  resolveOwners: (owners: OwnerPayload[]) => Promise<Owner[]>;
}

const ReviewSourceContext = createContext<ReviewSource | null>(null);

export const ReviewSourceProvider = ReviewSourceContext.Provider;
export const useReviewSource = () => useContext(ReviewSourceContext);
